import Vue from 'vue';
import {
  Button, Loading, CellGroup, Field, Popup, Area, Picker, Toast, Dialog, Icon, Circle,
} from 'vant';

Vue.use(Loading).use(Button).use(CellGroup).use(Field)
  .use(Popup)
  .use(Area)
  .use(Picker)
  .use(Toast)
  .use(Dialog)
  .use(Icon)
  .use(Circle);
